import { createStore } from 'vuex'
import * as cart from '@shopify/theme-cart'

const headerToggleClass = 'header-is-hidden'

export const store = createStore({
  state () {
    return {
      headerIsHidden: false,
      cart: {},
      cartIsInitialized: false,
      cartIsUpdating: true,
      currentOverlay: 'none'
    }
  },

  mutations: {
    SET_HEADER_IS_HIDDEN (state, { value }) {
      state.headerIsHidden = value
    },

    SET_CART (state, cart) {
      state.cart = cart
    },

    SET_CART_IS_INITIALIZED (state, { value }) {
      state.cartIsInitialized = value
    },

    SET_CART_IS_UPDATING (state, { value }) {
      state.cartIsUpdating = value
    },

    SET_CURRENT_OVERLAY (state, { name }) {
      state.currentOverlay = name
    }
  },

  actions: {
    hideHeader ({ state, commit }) {
      if (!state.headerIsHidden) {
        document.body.classList.add(headerToggleClass)
        commit('SET_HEADER_IS_HIDDEN', { value: true })
      }
    },

    showHeader ({ state, commit }) {
      if (state.headerIsHidden) {
        document.body.classList.remove(headerToggleClass)
        commit('SET_HEADER_IS_HIDDEN', { value: false })
      }
    },

    updateCart ({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_CART_IS_UPDATING', { value: true })
  
        cart
          .getState()
          .then((cart) => {
            commit('SET_CART', cart)
            commit('SET_CART_IS_UPDATING', { value: false })
            if (!state.cartIsInitialized) {
              commit('SET_CART_IS_INITIALIZED', { value: true })
            }

            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    changeCart ({ commit }, { key, quantity }) {
      return new Promise((resolve, reject) => {
        commit('SET_CART_IS_UPDATING', { value: true })
  
        cart
          .updateItem(key, { quantity })
          .then((state) => {
            commit('SET_CART', state)
            commit('SET_CART_IS_UPDATING', { value: false })
            
            resolve()
          })
          .catch((error) => {
            console.error('error', error.status, error.body)
            
            reject()
          })
      })
    },

    addToCart ({ dispatch, commit }, { form }) {
      return new Promise((resolve, reject) => {
        commit('SET_CART_IS_UPDATING', { value: true })
        
        cart.addItemFromForm(form)
          .then(() => {
            dispatch('updateCart')
              .then(() => {
                commit('SET_CURRENT_OVERLAY', { name: 'cart' })
                
                resolve()
              })
          })
          .catch((error) => {
            commit('SET_CART_IS_UPDATING', { value: false })
            
            reject(error)
          })
      })
    }
  }
})
